import { useMemo } from 'react';

import type { Client } from 'typesense';
import Typesense from 'typesense';

import { useTypesenseConfig } from '#src/app/shared/hooks/typesense';

type Result = ModelHookResult<{
	typesenseClient: Client;
}>;

export function useSearchClient(): Result {
	const { config } = useTypesenseConfig();

	const typesenseClient = useMemo(() => {
		return new Typesense.Client({
			nodes: config.nodes.map((node) => ({
				host: node.host,
				port: node.port,
				protocol: node.protocol,
				path: node.path,
			})),
			apiKey: config.apiKey,
			...(config.nearestNode
				? {
						nearestNode: {
							host: config.nearestNode.host,
							port: config.nearestNode.port,
							protocol: config.nearestNode.protocol,
							path: config.nearestNode.path,
						},
					}
				: {}),
			connectionTimeoutSeconds: 2,
		});
	}, [config]);

	return {
		data: {
			typesenseClient,
		},
	};
}
